export enum SessionBuilderEditModeEnum {
  View,
  Edit,
}
